"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTransformDataTapeFailure = exports.isTransformDataTapeSuccess = exports.isSanitizedTapeFailure = exports.isSanitizedTapeSuccess = exports.isInvalidField = exports.isFlattenError = exports.isFormulaError = exports.isJoinError = exports.isXlsx2CsvError = exports.isColumnValidationError = exports.isFieldValidationError = exports.isMetadataError = exports.isTransformError = exports.isRequiredBaseFieldConfig = exports.isStringBaseFieldConfig = exports.isPercentageBaseFieldConfig = exports.isIntegerBaseFieldConfig = exports.isFloatBaseFieldConfig = exports.isDateTimeBaseFieldConfig = exports.isDateBaseFieldConfig = exports.isCurrencyBaseFieldConfig = exports.isBooleanBaseFieldConfig = void 0;
const lodash_1 = __importDefault(require("lodash"));
const isBooleanBaseFieldConfig = (obj) => {
    return (obj && 'externalBooleanTrue' in obj && lodash_1.default.isString(obj.externalBooleanTrue));
};
exports.isBooleanBaseFieldConfig = isBooleanBaseFieldConfig;
const isCurrencyBaseFieldConfig = (obj) => {
    return obj && 'currencyCode' in obj && lodash_1.default.isString(obj.currencyCode);
};
exports.isCurrencyBaseFieldConfig = isCurrencyBaseFieldConfig;
const isDateBaseFieldConfig = (obj) => {
    return (obj && 'externalDateFormat' in obj && lodash_1.default.isString(obj.externalDateFormat));
};
exports.isDateBaseFieldConfig = isDateBaseFieldConfig;
const isDateTimeBaseFieldConfig = (obj) => {
    return (obj &&
        'externalDateTimeFormat' in obj &&
        lodash_1.default.isString(obj.externalDateTimeFormat));
};
exports.isDateTimeBaseFieldConfig = isDateTimeBaseFieldConfig;
const isFloatBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        (obj.type === 'float' || obj.type === 'optionalFloat'));
};
exports.isFloatBaseFieldConfig = isFloatBaseFieldConfig;
const isIntegerBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        (obj.type === 'integer' || obj.type === 'optionalInteger'));
};
exports.isIntegerBaseFieldConfig = isIntegerBaseFieldConfig;
const isPercentageBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        (obj.type === 'percentage' || obj.type === 'optionalPercentage'));
};
exports.isPercentageBaseFieldConfig = isPercentageBaseFieldConfig;
const isStringBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        (obj.type === 'string' || obj.type === 'optionalString'));
};
exports.isStringBaseFieldConfig = isStringBaseFieldConfig;
const isRequiredBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        lodash_1.default.isString(obj.type) &&
        !String(obj.type).startsWith('optional'));
};
exports.isRequiredBaseFieldConfig = isRequiredBaseFieldConfig;
const isTransformError = (obj) => {
    return obj && 'type' in obj && lodash_1.default.isString(obj.type);
};
exports.isTransformError = isTransformError;
const isMetadataError = (obj) => {
    return (0, exports.isTransformError)(obj) && obj.type === 'metadataValidation';
};
exports.isMetadataError = isMetadataError;
const isFieldValidationError = (obj) => {
    return (0, exports.isTransformError)(obj) && obj.type === 'fieldValidation';
};
exports.isFieldValidationError = isFieldValidationError;
const isColumnValidationError = (obj) => {
    return (0, exports.isTransformError)(obj) && obj.type === 'columnValidation';
};
exports.isColumnValidationError = isColumnValidationError;
const isXlsx2CsvError = (obj) => {
    return (0, exports.isTransformError)(obj) && obj.type === 'xlsx2Csv';
};
exports.isXlsx2CsvError = isXlsx2CsvError;
const isJoinError = (obj) => {
    return (0, exports.isTransformError)(obj) && obj.type === 'joinValidation';
};
exports.isJoinError = isJoinError;
const isFormulaError = (obj) => {
    return (0, exports.isTransformError)(obj) && obj.type === 'formulaValidation';
};
exports.isFormulaError = isFormulaError;
const isFlattenError = (obj) => {
    return (0, exports.isTransformError)(obj) && obj.type === 'flattenValidation';
};
exports.isFlattenError = isFlattenError;
const isInvalidField = (obj) => {
    return obj && 'expectedType' in obj && lodash_1.default.isString(obj.expectedType);
};
exports.isInvalidField = isInvalidField;
const isSanitizedTapeSuccess = (obj) => {
    return (obj &&
        'isValid' in obj &&
        'data' in obj &&
        obj.isValid === true &&
        lodash_1.default.isArray(obj.data));
};
exports.isSanitizedTapeSuccess = isSanitizedTapeSuccess;
const isSanitizedTapeFailure = (obj) => {
    return (obj &&
        'isValid' in obj &&
        'errors' in obj &&
        obj.isValid === false &&
        lodash_1.default.isArray(obj.errors));
};
exports.isSanitizedTapeFailure = isSanitizedTapeFailure;
const isTransformDataTapeSuccess = (obj) => {
    return (obj &&
        'isValid' in obj &&
        'data' in obj &&
        obj.isValid === true &&
        'outputDataTape' in obj.data &&
        'outputBuffer' in obj.data);
};
exports.isTransformDataTapeSuccess = isTransformDataTapeSuccess;
const isTransformDataTapeFailure = (obj) => {
    return (obj &&
        'isValid' in obj &&
        'errors' in obj &&
        obj.isValid === false &&
        lodash_1.default.isArray(obj.errors));
};
exports.isTransformDataTapeFailure = isTransformDataTapeFailure;
//# sourceMappingURL=typeguards.js.map